import { ViewableResponse } from '../types/global';

const autocompleteFormats = new Set(['AUTOCOMPLETE', 'AUTOCOMPLETE_OTHER']);

export const isAutocompleteResponse = (response: ViewableResponse): boolean =>
  !response.format || autocompleteFormats.has(response.format);

export const partitionAutocompleteResponses = (
  responses: ViewableResponse[],
): {
  autocompleteResponses: ViewableResponse[];
  belowResponses: ViewableResponse[];
} =>
  responses.reduce<{
    autocompleteResponses: ViewableResponse[];
    belowResponses: ViewableResponse[];
  }>(
    (partitioned, response) => {
      if (isAutocompleteResponse(response)) {
        partitioned.autocompleteResponses.push(response);
      } else {
        partitioned.belowResponses.push(response);
      }
      return partitioned;
    },
    { autocompleteResponses: [], belowResponses: [] },
  );
